<template>
  <!-- Empty template since this is primarily a utility component -->
</template>

<script lang="ts">
// Exporting utility functions
export function getActiveFilters(searchParams: URLSearchParams, filterKey: string): string[] {
    // Get all active filters for the given key
    if (!searchParams.has(filterKey)) return [];
    
    const value = searchParams.get(filterKey);
    if (!value) return [];
    
    // Split by comma to get multiple values
    return value.split(',');
}

export function removeFilterFromQuery(
    searchParams: URLSearchParams,
    filterKey: string,
    filterValue: string
) {
    // Get current values
    const values = getActiveFilters(searchParams, filterKey).filter(v => v !== filterValue);
    
    // Update or remove the parameter
    searchParams.delete(filterKey);
    if (values.length > 0) {
        searchParams.set(filterKey, values.join(','));
    }
}

export function updateQueryParamsAndReload(tmpFilters: any) {
    const searchParams = new URLSearchParams(window.location.search);

    // Preserve existing sort parameter
    const currentSort = searchParams.get('sort');

    // Clear existing filter parameters
    for (const key of searchParams.keys()) {
        const filterExistsInTmpFilters = tmpFilters.some(filter => filter.id === key);
        if (!filterExistsInTmpFilters && key !== 'sort') {
            searchParams.delete(key);
        }
    }

    // Remove sort to ensure it will be added last
    searchParams.delete('sort');

    // Add new filters
    tmpFilters.forEach(filter => {
        if (filter.values && filter.values.length > 0) {
            searchParams.set(filter.id, filter.values.join(','));
        }
    });

    // Add sorting as the last parameter if it existed (ensure lowercase in URL)
    if (currentSort) {
        searchParams.append('sort', currentSort.toLowerCase());
    }

    // Update URL without reloading the page
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.pushState({}, '', newUrl);
}

// Add a default export for the component
export default {
  name: 'FilterManager',
}
</script>
